import React from 'react';
import { useLanguage, Language, languageNames } from '../contexts/LanguageContext';

const LanguageSelector: React.FC = () => {
  const { language, setLanguage } = useLanguage();

  return (
    <div className="relative">
      <select
        value={language}
        onChange={(e) => setLanguage(e.target.value as Language)}
        className="w-full bg-white/10 text-white border border-white/20 rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-white/50 focus:shadow-lg focus:shadow-white/20 backdrop-filter backdrop-blur-sm appearance-none cursor-pointer"
      >
        {(Object.keys(languageNames) as Language[]).map((lang) => (
          <option 
            key={lang} 
            value={lang}
            className="bg-gray-900 text-white"
          >
            {languageNames[lang]}
          </option>
        ))}
      </select>
      <div className="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
        <svg className="w-4 h-4 text-white/70" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
      </div>
    </div>
  );
};

export default LanguageSelector;
